import { CAMPAING_STORAGE_KEY } from '../stores/campaign.atom';

const CAMPAIGNS_CACHE_KEY = 'precifield.campaigns.cache';

export const getCampaign = () => {
  const token = localStorage.getItem(CAMPAING_STORAGE_KEY);

  try {
    return JSON.parse(token as string);
  } catch {
    return token;
  }
};

export const getCurrentCampaignId = (): number | null => {
  try {
    const cached = localStorage.getItem(CAMPAIGNS_CACHE_KEY);
    if (cached) {
      const campaigns = JSON.parse(cached);
      const currentCampaign = campaigns.find(
        (c: { is_current: boolean }) => c.is_current === true,
      );
      return currentCampaign?.id || null;
    }
  } catch {
    return null;
  }
  return null;
};

export default getCampaign;
